import { CorporateIncomeTaxDetailContainer } from 'containers/accounting/corporate-income-tax-detail'

const CorporateIncomeTaxDetailPage = () => {
  return <CorporateIncomeTaxDetailContainer />
}

export default CorporateIncomeTaxDetailPage
